<div
  class="cb-layout-toolbar"
  [class.cb-divider]="divider()"
  [class.cb-tabs-toolbar]="hasTabs"
  [class.cb-single-item]="itemsLength() === 1"
  [ngClass]="'cb-' + area()"
>
  <ng-content select="cb-layout-item"></ng-content>
</div>
